<template>
  <div class="input-group input-group-sm">
    <select v-model="filter.operator" class="form-control form-control-sm">
      <optgroup label="Lookback">
        <option v-for="p in lookbackOperators" :key="p.value" :value="p.value">{{ p.label }}</option>
      </optgroup>
      <optgroup label="Relative date">
        <option value="relative:previous">Previous</option>
        <option value="relative:next">Next</option>
      </optgroup>
      <optgroup label="Specific date">
        <option value="between">Between</option>
        <option value="=">On</option>
        <option value="<">Before</option>
        <option value=">">After</option>
      </optgroup>
      <option value="isNull">Empty</option>
    </select>

    <template v-if="isRelative(filter.operator)">
      <input
        v-model.number="filter.value"
        type="number"
        min="1"
        class="form-control form-control-sm relative-amount"
        @keyup.enter="$emit('submit')"
      >
      <select v-model="filter.valueTwo" class="form-control form-control-sm">
        <option value="day">days</option>
        <option value="week">weeks</option>
        <option value="month">months</option>
      </select>
    </template>

    <template v-if="filter.operator === 'between'">
      <input v-model="filter.value" type="date" class="form-control form-control-sm" @keyup.enter="$emit('submit')">
      <span class="input-group-append">
        <span class="input-group-text">and</span>
      </span>
      <input v-model="filter.valueTwo" type="date" class="form-control form-control-sm" @keyup.enter="$emit('submit')">
    </template>

    <template v-if="isSingleDate(filter.operator)">
      <input v-model="filter.value" type="date" class="form-control form-control-sm" @keyup.enter="$emit('submit')">
    </template>
  </div>
</template>
<script>
  import { LOOKBACK_OPERATORS } from './date';

  export default {
    props: {
      filter: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        lookbackOperators: LOOKBACK_OPERATORS,
      };
    },
    watch: {
      'filter.operator'(newOp, oldOp) {
        if (this.isRelative(newOp) && !this.isRelative(oldOp)) {
          this.filter.value = '';
          this.filter.valueTwo = 'day';
        } else if (newOp === 'between') {
          this.filter.value = '';
          this.filter.valueTwo = '';
        } else if (this.isSingleDate(newOp) && !this.isSingleDate(oldOp)) {
          this.filter.value = '';
        }
      },
    },
    beforeMount() {
      if (!this.filter.operator) {
        this.filter.operator = 'lookback:yesterday';
      }
      if (!this.filter.valueTwo) {
        this.$set(this.filter, 'valueTwo', '');
      }
    },
    methods: {
      isRelative(operator) {
        return operator === 'relative:previous' || operator === 'relative:next';
      },
      isSingleDate(operator) {
        return operator === '=' || operator === '<' || operator === '>';
      },
    },
  };
</script>

<style scoped>
  input[type=date] {
    min-width: 120px;
  }
  .relative-amount {
    max-width: 70px;
  }
</style>
